import React from 'react';
import PropTypes from 'prop-types';

const MapPin = ({ fill }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.5 8.33398C16.5 10.8487 14.8593 13.3132 13.024 15.2504C12.1269 16.1974 11.2263 16.9732 10.5489 17.5126C10.3422 17.6773 10.157 17.8193 10 17.9368C9.84297 17.8193 9.65778 17.6773 9.45105 17.5126C8.77367 16.9732 7.87311 16.1974 6.97595 15.2504C5.14074 13.3132 3.5 10.8487 3.5 8.33398C3.5 6.61008 4.18482 4.95678 5.40381 3.73779C6.62279 2.5188 8.27609 1.83398 10 1.83398C11.7239 1.83398 13.3772 2.5188 14.5962 3.73779C15.8152 4.95678 16.5 6.61008 16.5 8.33398Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10.834C11.3807 10.834 12.5 9.7147 12.5 8.33398C12.5 6.95327 11.3807 5.83398 10 5.83398C8.61929 5.83398 7.5 6.95327 7.5 8.33398C7.5 9.7147 8.61929 10.834 10 10.834Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

MapPin.propTypes = {
  fill: PropTypes.string,
};

MapPin.defaultProps = {
  fill: '#4a4a4a',
};

export default MapPin;
